class SocialMediaUpdateItem {
  constructor(
    _id,
    id,
    socialMediaPlatform,
    socialMediaIcon,
    socialMedia,
    description,
    createdAt,
    embedUrl,
    embedHtml
  ) {
    this._id = _id;
    this.id = id;
    this.socialMediaPlatform = socialMediaPlatform || null;
    this.socialMediaIcon = socialMediaIcon || null;
    // socialMedia may be an id (string) or a populated object
    this.socialMedia = socialMedia || null;
    this.description = description || "";
    this.createdAt = createdAt || null;
    this.embedUrl = embedUrl || null;
    this.embedHtml = embedHtml || null;
  }

  static fromJSON(json = {}) {
    // id/_id
    const _id = json._id || json.id || null;
    const id = json.id || json._id || null;

    // socialMediaPlatform / platform (may be top-level or nested under populated socialMedia)
    const socialMediaPlatform = json.socialMediaPlatform || json.platform || (json.socialMedia && (json.socialMedia.platform || json.socialMedia.name)) || null;

    // socialMediaIcon / icon (top-level or nested)
    const socialMediaIcon = json.socialMediaIcon || json.icon || (json.socialMedia && (json.socialMedia.icon || json.socialMedia.image)) || null;

    // socialMedia can be an ObjectId string or a populated object
    let socialMediaVal = null;
    if (json.socialMedia) {
      if (typeof json.socialMedia === 'string') socialMediaVal = json.socialMedia;
      else if (json.socialMedia._id) socialMediaVal = json.socialMedia._id;
      else socialMediaVal = json.socialMedia;
    } else if (json.socialMediaId) {
      socialMediaVal = json.socialMediaId;
    }

    const description = json.description || json.body || json.text || "";

    const embedUrl = json.embedUrl || json.postUrl || json.shareUrl || json.url || json.link || null;
    const embedHtml = json.embedHtml || json.embedCode || null;

    const created = json.createdAt || json.created_at || json.publishedAt || json.published_at || null;
    let parsedCreated = null;
    if (created) {
      const n = Number(created);
      if (!Number.isNaN(n) && String(created).trim() !== '') {
        // timestamp in seconds (10-digit) vs ms (13-digit)
        parsedCreated = new Date(n < 1e12 ? n * 1000 : n);
      } else {
        const dt = new Date(created);
        parsedCreated = isNaN(dt.getTime()) ? created : dt;
      }
    }

    return new SocialMediaUpdateItem(
      _id,
      id,
      socialMediaPlatform,
      socialMediaIcon,
      socialMediaVal,
      description,
      parsedCreated,
      embedUrl,
      embedHtml
    );
  }

  toJSON() {
    return {
      _id: this._id,
      id: this.id,
      socialMediaPlatform: this.socialMediaPlatform,
      socialMediaIcon: this.socialMediaIcon,
      socialMedia: this.socialMedia,
      description: this.description,
      createdAt: this.createdAt ? (this.createdAt instanceof Date ? this.createdAt.toISOString() : this.createdAt) : null,
      embedUrl: this.embedUrl,
      embedHtml: this.embedHtml,
    };
  }
}

module.exports = SocialMediaUpdateItem;
